import { useTranslation } from 'react-i18next'
import { DashboardBigCard } from '../components'
import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { sum } from 'lodash'

export const MonthlyComplianceBox = ({ monthlyAttachments }) => {
  const { t } = useTranslation()

  const monthlyCompliancePercentage = useMemo(() => {
    console.log({ monthlyAttachments })
    if (!Object.keys(monthlyAttachments).length) return 0

    const approvedPercentages = []
    const monthKeys = Object.keys(monthlyAttachments)

    let monthsWithAttachmentsCount = 0
    monthKeys.forEach(monthKey => {
      const currentMonthData = monthlyAttachments[monthKey]
      const currentMonthHasAttachments = Object.keys(currentMonthData.details).length > 0

      if (currentMonthHasAttachments) {
        monthsWithAttachmentsCount++
      }

      const { status_percentages: statusPercentages } = currentMonthData
      approvedPercentages.push(
        statusPercentages.approved
      )
    })

    return (sum(approvedPercentages) / monthsWithAttachmentsCount).toFixed(1)
  }, [monthlyAttachments])

  return (
    <DashboardBigCard
      title={t('dashboard.bigCard.monthlyCompliancee.title')}
      value={monthlyCompliancePercentage}
      footerDescription={t(
        'dashboard.bigCard.monthlyCompliancee.footerDescription'
      )}
      tooltipTitle={t(
        'dashboard.bigCard.monthlyCompliancee.tooltipTitle'
      )}
      tooltipDescription={t(
        'dashboard.bigCard.monthlyCompliancee.tooltipDescription'
      )}
    />
  )
}

MonthlyComplianceBox.propTypes = {
  monthlyAttachments: PropTypes.object
}
